export interface H5pLibrarySummary {
  name?: string;
  machineName?: string;
  version?: string;
  major?: number;
  minor?: number;
}

export interface H5pPackage {
  id: string;
  title: string;
  library?: string;
  mainLibrary?: string | H5pLibrarySummary | null;
  version?: string;
  versionCount?: number;
  currentVersion?: { versionNumber?: number };
  status?: string;
  usageCount?: number;
  thumbnailUrl?: string;
}

export function packageLibraryLabel(pkg: H5pPackage): string {
  if (pkg.library) return pkg.library;
  const lib = pkg.mainLibrary;
  if (!lib) return 'Sin librería';
  if (typeof lib === 'string') return lib;
  const name = lib.machineName ?? lib.name;
  if (!name) return 'Sin librería';
  if (lib.version) return `${name} ${lib.version}`;
  if (lib.major != null && lib.minor != null) return `${name} ${lib.major}.${lib.minor}`;
  return name;
}

export function packageVersionCount(pkg: H5pPackage): number {
  if (pkg.versionCount != null) return pkg.versionCount;
  return pkg.currentVersion?.versionNumber ?? 1;
}

export function packageCourseCount(pkg: H5pPackage): number {
  return pkg.usageCount ?? 0;
}

export function packageMachineName(pkg: H5pPackage): string {
  const lib = pkg.mainLibrary;
  if (lib && typeof lib === 'object') return lib.machineName ?? '';
  return '';
}

export function packageLibraryIcon(machineName: string): string {
  if (machineName.includes('Drag')) return 'pan_tool';
  if (machineName.includes('MultiChoice') || machineName.includes('Question')) return 'list_alt';
  if (machineName.includes('Video')) return 'movie';
  if (machineName.includes('Audio')) return 'headphones';
  if (machineName.includes('Image')) return 'image';
  if (machineName.includes('CoursePresentation')) return 'slideshow';
  if (machineName.includes('InteractiveVideo')) return 'smart_display';
  if (machineName.includes('Accordion')) return 'view_agenda';
  if (machineName.includes('Blanks')) return 'edit_note';
  return 'extension';
}

export type H5pStatusModifier = 'active' | 'archived';

export function packageStatusModifier(status?: string): H5pStatusModifier {
  if (status === 'archived' || status === 'draft') return 'archived';
  return 'active';
}

export function packageStatusLabel(status?: string): string {
  switch (status) {
    case 'published':
    case 'active':
      return 'Activa';
    case 'archived':
      return 'Archivada';
    case 'draft':
      return 'Borrador';
    default:
      return 'Borrador';
  }
}
